module.exports =  {

  howToCancelOrder: {
    title: '如何撤销挂单？',
    contents: `
      <p>如果您是一笔交易的吃单者（Taker），如果这笔交易已经完成（代币已经转手），那么您无法取消这笔交易。</p>
      <p>如果您是挂单者（Maker），而您的挂单还没有被完全吃单或失效，这时您可以撤销这一挂单。撤销方法是打开”我的挂单“页面，找到要撤销的挂单，点击”撤销挂单“按钮（已失效的挂单不会显示这一按钮）。</p>
      <p>请注意：撤销挂单时需要交付以太坊矿工费（Gas）。</p>
  `,
  },

}
